var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullCallSpread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 22H61.5V17.5H42L26 33.5H32.5L44 22Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7058 38.5L25.9999 33.5H32.4999L27.4999 38.5L23 43H7V38.5H20.7058Z",
    fill: "#E94C69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 33.5V33H25.8011L25.6566 33.1365L25.9999 33.5ZM20.7058 38.5V39H20.9046L21.0491 38.8635L20.7058 38.5ZM32.4999 33.5L32.8535 33.8536L33.707 33H32.4999V33.5ZM27.4999 38.5L27.1464 38.1464L26.2928 39H27.4999V38.5ZM27.4999 38.5L27.8535 38.8536L28.7071 38H27.5L27.4999 38.5ZM23 43V43.5H23.2071L23.3535 43.3536L23 43ZM7 43H6.5V43.5H7V43ZM7 38.5V38H6.5V38.5H7ZM25.6566 33.1365L20.3625 38.1365L21.0491 38.8635L26.3432 33.8635L25.6566 33.1365ZM32.4999 33H25.9999V34H32.4999V33ZM27.8535 38.8536L32.8535 33.8536L32.1464 33.1464L27.1464 38.1464L27.8535 38.8536ZM23.3535 43.3536L27.8535 38.8536L27.1464 38.1464L22.6464 42.6464L23.3535 43.3536ZM7 43.5H23V42.5H7V43.5ZM6.5 38.5V43H7.5V38.5H6.5ZM20.7058 38H7V39H20.7058V38Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullCallSpread);
export default __webpack_public_path__ + "static/media/Bull Call Spread.0a1f9cdd38d46eaaeea490dbb66d5fff.svg";
export { ForwardRef as ReactComponent };